import { Component, OnInit, Input } from '@angular/core'
import { Dictionary } from '@ngrx/entity';
import { JoiEvent, Ranking } from 'globals/store/events.data';
import { CoreEntityType, performerBriefMediaStatus } from 'globals/store/share.data'
import { openConfirmDeleteGetResult } from '../dialog.confirmDelete.component';
import { DotMenuItem } from '../misc/dot-menu.component';
import { Wrapper } from '../wrapper.component';
import { MediaTerms } from 'globals/store/events.data';
import { CommonModule } from '@angular/common';
import { JoiInputComponent } from '../joi-input/joi-input.component';
import { GreyCardComponent } from '../cards/grey-card.component';
import { GreyWrapperComponent } from '../wrappers/grey-wrapper.component';
import { TitleToggleComponent } from '../wrappers/title-toggle-wrapper.component';
import { EntityTypeDropdownComponent } from '../entities/entity-type-dropdown.component';

@Component({
    selector: 'media-terms',
    template: `
<title-toggle-wrapper
  [title]="'Include terms in ' + type + ' brief'"
  [hideToggle]="readOnly"
  [dotMenuItems]="dotMenuItems"
  [toggleOn]="terms.use"
  (toggle)="toggle($event)"
  (dotMenuSelection)="dotMenuSelection($event)"
  >
  <type-select-dropdown class="afterTitle" *ngIf="type"
    [entityType]="type"
    [ids]="terms.typeIds || []"
    [types]="entityTypesMap"
    (selectIds)="updateEntityTypeIds($event)"
  ></type-select-dropdown>
  <div class="media-terms-inputs" *ngIf="!!terms.use">
    <div class="toggle-section">
      <grey-wrapper class="half-column">
        <h5>Title</h5>
        <joi-input 
          [italicPlaceholder]="true" 
          [fixedWidth]="true" 
          [disabled]="readOnly" 
          [(model)]="terms.name" 
          [placeholder]="'Terms name...'" 
          (joiChange)="updateTermsName()"
        ></joi-input>
      </grey-wrapper>
    </div>
    <div *ngIf="!linkOk && terms.url" class="urlerror">This is not a url and has not been saved</div><!--joi-input doesn't have an invalid state but this solution is bad-->
    <div class="toggle-section">
      <grey-wrapper class="half-column">
        <h5>Terms URL</h5>
        <joi-input 
          [italicPlaceholder]="true" 
          [fixedWidth]="true" 
          [disabled]="readOnly" 
          [(model)]="terms.url" 
          [placeholder]="'https://...'" 
          (keyup)="checkLinkUrl()"
          (joiChange)="updateURL()"
        ></joi-input>
      </grey-wrapper>
    </div>
</div>
  <ng-container *ngIf="!terms.use">
    Turn this area on if your {{ type }}s need to accept terms. You can add a URL to your hosted terms and an “Accept Terms” function will be added to the {{ type | titlecase }} Brief area.
  </ng-container>
  <div *ngIf="!!terms.use">
    Note: Your Terms need to be generic for all {{ type }}s and must be hosted on a public URL eg. your website or on Dropbox. The terms URL will be included in the {{ type | titlecase }} Brief so your {{ type }}(s) can read before accepting.
  </div> 
</title-toggle-wrapper>
`,
    styles: [`
  .grey-hint { margin-top: 10px; font-style: normal; }
  .dropdown-holder { display: flex; align-items: center; margin-left: 5px;}
  .toggle-section grey-wrapper { margin-bottom: 10px; }
  h5 { text-transform: unset; }
  ::ng-deep performer-media-release-manager .toggle-section .wrapper { border: unset }
  .media-terms-inputs { margin: 10px 0; }
  joi-input { margin: 2px 0px -5px -3px; display: block; }
  .urlerror { font-size: 12px; color: #f05454; }
  icon.more { cursor: pointer; color: #999; margin: 2px 0 0 5px; }
`],
    styleUrls: ["../../modules/manage/manage-call-to-action.scss"],
    standalone: true,
    imports: [CommonModule, JoiInputComponent, GreyWrapperComponent, TitleToggleComponent, EntityTypeDropdownComponent],
})
export class MediaTermsComponent extends Wrapper<MediaTermsComponent> implements OnInit {
  @Input() terms: MediaTerms
  @Input() type: CoreEntityType
  @Input() entityTypesMap: Dictionary<Ranking> = {}


  dotMenuItems: DotMenuItem[] = [{ id: 'delete', title: 'Delete' }]

  readOnly = false

  linkOk = false;
  statusOptions = performerBriefMediaStatus
  pattern:RegExp = new RegExp('^https?:\/\/(.*)\.(.*)')
  event: JoiEvent

  async dotMenuSelection({ id, event }) {
    const data = {
      title: `Delete ${this.terms.name || 'Terms'}`,
      rect: event.target.getBoundingClientRect(),
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.eventService.deleteTerms(this.terms, this.type)
  }
  
  ngOnInit(){
    this.subCallback(this.store.select('events', 'event'), (event: JoiEvent) => {
      this.event = event
      this.readOnly = !event || event.is_readonly
    })
    this.checkLinkUrl()
  }

  toggle(toggled: boolean) {
    this.terms.use = toggled
    this.updateTerms()
  }

  updateEntityTypeIds(typeIds: string[]) {
    this.terms.typeIds = typeIds
    this.updateTerms()
  }

  checkLinkUrl(){
    this.linkOk = this.pattern.test(this.terms.url)
  }

  updateTermsName() {
    this.updateTerms()
  }

  updateTerms() {
    this.eventService.updateTerms(this.terms, this.type)
  }

  updateURL(){
    this.checkLinkUrl()
    if (this.linkOk) {
      this.updateTerms()
    }
  }
  
}






